<template>
  <div class="delete-task__form">
    <h2>Удалить {{ ProjectTask.getTypeLabel(task.parentId) }}?</h2>
    <p>
      Вы действительно хотите удалить {{ ProjectTask.getTypeLabel(task.parentId) }} из списка?
    </p>
    <a-row class="form__task-info">
      <a-col>
        <h3>{{ task.name }}</h3>
      </a-col>
      <a-col class="form__task-group" v-if="task.subtasks">
        Подзадач:<span class="counter">{{ task.subtasks.length }}</span>
      </a-col>
      <a-col class="form__task-group">
        Контрольных точек:
        <span class="counter"> 
          {{ getCheckpointsCount(task) }}
        </span>
      </a-col>
    </a-row>

    <div class="delete-task__form-button">
      <c-button-danger @click="deleteTask">Удалить</c-button-danger>
    </div>
  </div>
</template>

<script setup>
  import { useApi } from "@/api/use-api";
  import CButtonDanger from "@/components/UI/CButtonDanger";
  import { ProjectTask } from "./adapters/project-task";

  const props = defineProps({
    /**
     * Объект задачи / подзадачи.
     */
    task: {
      type: Object,
      required: true,
    },
  });

  const api = useApi();
  const emit = defineEmits([
    /**
     * Событие срабатывает при удалении задачи.
     */
    'deleted',
  ]);

  /**
   * Подсчет количества контрольных точек у задачи вместе с подзадачами.
   * @param {Object} task
   */
  const getCheckpointsCount = (task) => {
    const taskCheckpointsCount = task.checkpoints.length;

    if (task.subtasks) {
      const subtasksCheckpointsCount = task.subtasks
        .map((subtask) => subtask.checkpoints)
        .flat().length;
      return taskCheckpointsCount + subtasksCheckpointsCount;
    }

    return taskCheckpointsCount;
  };

  const deleteTask = async () => {
    try {
      await api.projectTask.remove(props.task.id);
      emit('deleted');
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  * {
    margin: 0;
  }

  .delete-task__form {
    padding: 112px 17px 0 17px;

    h2 {
      font: 700 18px/26px "Nunito Sans";
    }

    h3 {
      font: 700 14px/20px "Nunito Sans";
    }

    p {
      margin-top: 21px;
    }

    .form__task-info {
      background: $color-bg-secondary-grey;
      flex-direction: column;
      height: 161px;
      margin-top: 40px;
      padding: 20px;

      .form__task-group {
        color: $color-bg-status-new;
        font: 700 14px/20px "Nunito Sans";
        margin-top: 18px;

        .counter {
          font-weight: 400;
          margin-left: 10px;
        }
      }
    }

    &-button {
      margin-top: 50px;
      text-align: right;
    }
  }
</style>
